import { Variants } from '../types/variant';

export const etpSommeilVariants = {
  etp_sommeil: {
    name: 'ETP HDJ Sommeil',
    status: 'restricted',
    description:
      "Questionnaire de bilan éducatif partagé pour les patients atteints du syndrome d'apnées obstructives du sommeil au Centre Hospitalier de Bligny. Couvre la situation personnelle, le vécu de la maladie, l'utilisation de la PPC, l'impact sur la vie quotidienne, l'alimentation et les projets du patient.",
    speciality: 'ETP-SOMMEIL',
    patientOnboarding: 'ETP_SOMMEIL',
    patientOffboarding: 'DIRECT_CONFIRMATION',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'QUESTIONS_ANSWERS',
    initialQuestions: [],
    initialAssertions: [],
    pages: {
      INTRO: { title: 'Introduction', sections: ['INTRODUCTION'] },
      WHO: { title: 'Qui êtes-vous ?', sections: ['SITUATION'] },
      VIE: { title: 'Votre vie', sections: ['VIE'] },
      SAOS: {
        title: "Le Syndrome d'Apnées Obstructives du Sommeil",
        sections: ['SAOS'],
      },
      CPAP: { title: 'Utilisation de la machine', sections: ['CPAP'] },
      SOM: { title: "Votre sommeil aujourd'hui ", sections: ['SOM'] },
      IMPACT: {
        title: 'La maladie et son impact sur la vie quotidienne',
        sections: ['IMPACT'],
      },
      ALIM: { title: 'Alimentation', sections: ['ALIM'] },
      PROJ: { title: 'Vos projets', sections: ['PROJ'] },
      CONCLUSION: { title: 'Conclusion', sections: ['RECAP'] },
    },
    options: [],
    tag: 'ETP',
    visitMotive: 'Bilan Éducatif Partagé',
  },
} satisfies Variants;
